export const ERROR_404 = '404';
export const TEXT = 'Сторінку не знайдено';
export const GO_BACK_BUTTON = 'Повернутись на головну';
export const DESCRIPTION =
    'На жаль, за цим посиланням нічого немає. Спробуйте почати з головної або звернутись до нашої команди.';
